// src/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nflxornaepsvizrchfzv.supabase.co';   // ← paste here (your URL)

const supabaseAnonKey = 'sb_publishable_5jl-_QN1czgPRAehDDTVXg_OEGncei_';   // ← you already copied this from API Keys page

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
